import { render, staticRenderFns } from "./RequireAddress.vue?vue&type=template&id=70b0f7e3&"
import script from "./RequireAddress.vue?vue&type=script&lang=js&"
export * from "./RequireAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b0f7e3')) {
      api.createRecord('70b0f7e3', component.options)
    } else {
      api.reload('70b0f7e3', component.options)
    }
    module.hot.accept("./RequireAddress.vue?vue&type=template&id=70b0f7e3&", function () {
      api.rerender('70b0f7e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/lot/components/RequireAddress.vue"
export default component.exports